// extracted by mini-css-extract-plugin
export var modalFooter = "_qv-0";